export const SET_SIDE_BAR_OPEN = 'SET_SIDE_BAR_OPEN';
export const SET_SIDE_BAR_CLOSED = 'SET_SIDE_BAR_CLOSED';

export const ADD_UI_LOADING_ACTION = 'ADD_UI_LOADING_ACTION';
export const REMOVE_UI_LOADING_ACTION = 'REMOVE_UI_LOADING_ACTION';

export const FETCH_NOMINATIONS_STARTED = 'FETCH_NOMINATIONS_STARTED';
export const FETCH_NOMINATIONS_SUCCESS = 'FETCH_NOMINATIONS_SUCCESS';
export const FETCH_NOMINATIONS_FAILED = 'FETCH_NOMINATIONS_FAILED';
export const FETCH_NOMINATIONS_ENDED = 'FETCH_NOMINATIONS_ENDED';

export const ADD_NOMINATIONS_STARTED = 'ADD_NOMINATIONS_STARTED';
export const ADD_NOMINATIONS_SUCCESS = 'ADD_NOMINATIONS_SUCCESS';
export const ADD_NOMINATIONS_FAILED = 'ADD_NOMINATIONS_FAILED';
export const ADD_NOMINATIONS_ENDED = 'ADD_NOMINATIONS_ENDED';

export const DELETE_NOMINATIONS_STARTED = 'DELETE_NOMINATIONS_STARTED';
export const DELETE_NOMINATIONS_SUCCESS = 'DELETE_NOMINATIONS_SUCCESS';
export const DELETE_NOMINATIONS_FAILED = 'DELETE_NOMINATIONS_FAILED';
export const DELETE_NOMINATIONS_ENDED = 'DELETE_NOMINATIONS_ENDED';

export const FETCH_SEARCH_RESULTS_STARTED = 'FETCH_SEARCH_RESULTS_STARTED';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_FAILED = 'FETCH_SEARCH_RESULTS_FAILED';
export const FETCH_SEARCH_RESULTS_ENDED = 'FETCH_SEARCH_RESULTS_ENDED';

export const UI_ADD = 'UI_ADD';
export const UI_REMOVE = 'UI_REMOVE';

export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
